/**
 * /**
 *  * Generated by orval v1.0.0 🍃
 *  * Do not edit manually.
 *  * Citrus API
 *  * API for Citrus platform
 *  *\/
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  PaginatedRegionList,
  PatchedRegionUpdateRequest,
  RegionCreateRequest,
  RegionCreateResponse,
  RegionDeleteResponse,
  RegionGetResponse,
  RegionPutResponse,
  RegionUpdateRequest,
  RegionUpdateResponse,
  RegionsListParams
} from '../../models';

import { customInstance } from '../../../axios-instance';




/**
 * Retrieve a paginated list of regions with optional client and scope filtering. Client users see regions owned by their client or global regions without an owner. Use scope=contextual for universal regions or scope=client for client-owned regions.
 * @summary List regions
 */
export const regionsList = (
    params?: RegionsListParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PaginatedRegionList>(
      {url: `/api/regions/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getRegionsListQueryKey = (params?: RegionsListParams,) => {
    return [`/api/regions/`, ...(params ? [params]: [])] as const;
    }

    
export const getRegionsListQueryOptions = <TData = Awaited<ReturnType<typeof regionsList>>, TError = unknown>(params?: RegionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof regionsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRegionsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof regionsList>>> = ({ signal }) => regionsList(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof regionsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RegionsListQueryResult = NonNullable<Awaited<ReturnType<typeof regionsList>>>
export type RegionsListQueryError = unknown


export function useRegionsList<TData = Awaited<ReturnType<typeof regionsList>>, TError = unknown>(
 params: undefined |  RegionsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof regionsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof regionsList>>,
          TError,
          Awaited<ReturnType<typeof regionsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRegionsList<TData = Awaited<ReturnType<typeof regionsList>>, TError = unknown>(
 params?: RegionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof regionsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof regionsList>>,
          TError,
          Awaited<ReturnType<typeof regionsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRegionsList<TData = Awaited<ReturnType<typeof regionsList>>, TError = unknown>(
 params?: RegionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof regionsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List regions
 */

export function useRegionsList<TData = Awaited<ReturnType<typeof regionsList>>, TError = unknown>(
 params?: RegionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof regionsList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRegionsListQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Create a new region
 * @summary Create region
 */
export const regionsCreate = (
    regionCreateRequest: RegionCreateRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<RegionCreateResponse>(
      {url: `/api/regions/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: regionCreateRequest, signal
    },
      );
    }
  


export const getRegionsCreateMutationOptions = <TError = RegionCreateResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regionsCreate>>, TError,{data: RegionCreateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof regionsCreate>>, TError,{data: RegionCreateRequest}, TContext> => {

const mutationKey = ['regionsCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof regionsCreate>>, {data: RegionCreateRequest}> = (props) => {
          const {data} = props ?? {};

          return  regionsCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RegionsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof regionsCreate>>>
    export type RegionsCreateMutationBody = RegionCreateRequest
    export type RegionsCreateMutationError = RegionCreateResponse

    /**
 * @summary Create region
 */
export const useRegionsCreate = <TError = RegionCreateResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regionsCreate>>, TError,{data: RegionCreateRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof regionsCreate>>,
        TError,
        {data: RegionCreateRequest},
        TContext
      > => {

      const mutationOptions = getRegionsCreateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Get a single region by ID
 * @summary Retrieve region
 */
export const regionsRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<RegionGetResponse>(
      {url: `/api/regions/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getRegionsRetrieveQueryKey = (id: string,) => {
    return [`/api/regions/${id}`] as const;
    }

    
export const getRegionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof regionsRetrieve>>, TError = RegionGetResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof regionsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRegionsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof regionsRetrieve>>> = ({ signal }) => regionsRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof regionsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RegionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof regionsRetrieve>>>
export type RegionsRetrieveQueryError = RegionGetResponse


export function useRegionsRetrieve<TData = Awaited<ReturnType<typeof regionsRetrieve>>, TError = RegionGetResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof regionsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof regionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof regionsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRegionsRetrieve<TData = Awaited<ReturnType<typeof regionsRetrieve>>, TError = RegionGetResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof regionsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof regionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof regionsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRegionsRetrieve<TData = Awaited<ReturnType<typeof regionsRetrieve>>, TError = RegionGetResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof regionsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieve region
 */

export function useRegionsRetrieve<TData = Awaited<ReturnType<typeof regionsRetrieve>>, TError = RegionGetResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof regionsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRegionsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Fully update a region
 * @summary Update region (full)
 */
export const regionsUpdate = (
    id: string,
    regionUpdateRequest: RegionUpdateRequest,
 ) => {
      
      
      return customInstance<RegionPutResponse>(
      {url: `/api/regions/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: regionUpdateRequest
    },
      );
    }
  


export const getRegionsUpdateMutationOptions = <TError = RegionPutResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regionsUpdate>>, TError,{id: string;data: RegionUpdateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof regionsUpdate>>, TError,{id: string;data: RegionUpdateRequest}, TContext> => {

const mutationKey = ['regionsUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof regionsUpdate>>, {id: string;data: RegionUpdateRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  regionsUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RegionsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof regionsUpdate>>>
    export type RegionsUpdateMutationBody = RegionUpdateRequest
    export type RegionsUpdateMutationError = RegionPutResponse

    /**
 * @summary Update region (full)
 */
export const useRegionsUpdate = <TError = RegionPutResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regionsUpdate>>, TError,{id: string;data: RegionUpdateRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof regionsUpdate>>,
        TError,
        {id: string;data: RegionUpdateRequest},
        TContext
      > => {

      const mutationOptions = getRegionsUpdateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Partially update a region
 * @summary Update region
 */
export const regionsPartialUpdate = (
    id: string,
    patchedRegionUpdateRequest: PatchedRegionUpdateRequest,
 ) => {
      
      
      return customInstance<RegionUpdateResponse>(
      {url: `/api/regions/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedRegionUpdateRequest
    },
      );
    }
  


export const getRegionsPartialUpdateMutationOptions = <TError = RegionUpdateResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regionsPartialUpdate>>, TError,{id: string;data: PatchedRegionUpdateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof regionsPartialUpdate>>, TError,{id: string;data: PatchedRegionUpdateRequest}, TContext> => {

const mutationKey = ['regionsPartialUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof regionsPartialUpdate>>, {id: string;data: PatchedRegionUpdateRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  regionsPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RegionsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof regionsPartialUpdate>>>
    export type RegionsPartialUpdateMutationBody = PatchedRegionUpdateRequest
    export type RegionsPartialUpdateMutationError = RegionUpdateResponse

    /**
 * @summary Update region
 */
export const useRegionsPartialUpdate = <TError = RegionUpdateResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regionsPartialUpdate>>, TError,{id: string;data: PatchedRegionUpdateRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof regionsPartialUpdate>>,
        TError,
        {id: string;data: PatchedRegionUpdateRequest},
        TContext
      > => {

      const mutationOptions = getRegionsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Delete a region by ID
 * @summary Delete region
 */
export const regionsDestroy = (
    id: string,
 ) => {
      
      
      return customInstance<RegionDeleteResponse>(
      {url: `/api/regions/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getRegionsDestroyMutationOptions = <TError = RegionDeleteResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regionsDestroy>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof regionsDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['regionsDestroy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof regionsDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  regionsDestroy(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RegionsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof regionsDestroy>>>
    
    export type RegionsDestroyMutationError = RegionDeleteResponse

    /**
 * @summary Delete region
 */
export const useRegionsDestroy = <TError = RegionDeleteResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regionsDestroy>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof regionsDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getRegionsDestroyMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    